import React from "react";

const HiringProcess = () => {

    const steps = [
        {
            number: "01",
            title: "Apply",
            desc: "Submit your application and tell us about your skills, experience and career goals."
        },
        {
            number: "02",
            title: "Screening",
            desc: "Our team reviews your profile and evaluates how well your experience matches the role."
        },
        {
            number: "03",
            title: "Technical Interview",
            desc: "Showcase your technical expertise, problem-solving abilities and development approach."
        },
        {
            number: "04",
            title: "Final Discussion",
            desc: "Meet with leadership to discuss expectations, culture fit and future opportunities."
        },
        {
            number: "05",
            title: "You're Hired",
            desc: "Welcome to AppVerseLabs. Start building amazing digital experiences with us."
        }
    ];

    return (
        <>
            <section className="hp-section">

                <div className="hp-glow glow1"></div>
                <div className="hp-glow glow2"></div>

                <div className="hp-container">

                    <div className="hp-header">

                        <span>HIRING PROCESS</span>

                        <h2>
                            Your Journey
                            <br />
                            Starts Here
                        </h2>

                        <p>
                            Our hiring process is designed to be transparent,
                            efficient and focused on finding talented people
                            who are excited to build great products.
                        </p>

                    </div>

                    <div className="hp-timeline">

                        <div className="hp-line"></div>

                        {steps.map((step, index) => (

                            <div
                                key={index}
                                className={`hp-item ${index % 2 === 0
                                        ? "left"
                                        : "right"
                                    }`}
                            >

                                <div className="hp-dot"></div>

                                <div className="hp-card">

                                    <div className="hp-number">
                                        {step.number}
                                    </div>

                                    <h3>
                                        {step.title}
                                    </h3>

                                    <p>
                                        {step.desc}
                                    </p>

                                </div>

                            </div>

                        ))}

                    </div>

                </div>

                <style>{`

                .hp-section{
                    position:relative;
                    padding:150px 24px;
                    background:#fff;
                    overflow:hidden;
                }

                .hp-container{
                    max-width:1200px;
                    margin:auto;
                    position:relative;
                    z-index:2;
                }

                .hp-header{
                    text-align:center;
                    margin-bottom:100px;
                }

                .hp-header span{
                    display:inline-block;
                    padding:12px 22px;
                    border-radius:999px;
                    background:rgba(232,33,42,.08);
                    color:#E8212A;
                    font-size:13px;
                    font-weight:700;
                    margin-bottom:24px;
                    letter-spacing:1px;
                }

                .hp-header h2{
                    font-size:clamp(35px,7vw,58px);
                    line-height:.95;
                    color:#111;
                    text-align: center;
                    margin-bottom:20px;
                    font-family:'Syne',sans-serif;
                }

                .hp-header p{
                    max-width:700px;
                    text-align: center;
                    margin:auto;
                    color:#666;
                    line-height:1.9;
                    font-size:18px;
                }

                .hp-timeline{
                    position:relative;
                }

                .hp-line{
                    position:absolute;
                    left:50%;
                    top:0;
                    transform:translateX(-50%);
                    width:4px;
                    height:100%;
                    border-radius:20px;
                    background:
                    linear-gradient(
                        180deg,
                        #E8212A,
                        #FF4D4D
                    );
                }

                .hp-item{
                    position:relative;
                    width:50%;
                    margin-bottom:70px;
                }

                .hp-item.left{
                    padding-right:60px;
                }

                .hp-item.right{
                    margin-left:50%;
                    padding-left:60px;
                }

                .hp-dot{
                    position:absolute;
                    top:50px;
                    width:24px;
                    height:24px;
                    border-radius:50%;
                    background:#E8212A;
                    border:5px solid #fff;
                    box-shadow:
                    0 0 0 8px rgba(232,33,42,.15);
                    z-index:2;
                }

                .left .hp-dot{
                    right:-12px;
                }

                .right .hp-dot{
                    left:-12px;
                }

                .hp-card{
                    background:#fff;
                    border:1px solid #eee;
                    border-radius:30px;
                    padding:35px;
                    transition:.4s ease;
                    box-shadow:
                    0 15px 40px rgba(0,0,0,.05);
                }

                .hp-card:hover{
                    transform:translateY(-10px);
                    border-color:#E8212A;
                    box-shadow:
                    0 25px 80px rgba(232,33,42,.12);
                }

                .hp-number{
                    font-size:60px;
                    color:#E8212A;
                    font-weight:800;
                    line-height:1;
                    margin-bottom:20px;
                    font-family:'Syne',sans-serif;
                }

                .hp-card h3{
                    font-size:34px;
                    margin-bottom:15px;
                    color:#111;
                    font-family:'Syne',sans-serif;
                }

                .hp-card p{
                    color:#666;
                    line-height:1.9;
                    font-size:15px;
                }

                .hp-glow{
                    position:absolute;
                    border-radius:50%;
                    filter:blur(120px);
                    opacity:.12;
                }

                .glow1{
                    width:400px;
                    height:400px;
                    background:#E8212A;
                    left:-120px;
                    top:-120px;
                }

                .glow2{
                    width:350px;
                    height:350px;
                    background:#FF4D4D;
                    right:-120px;
                    bottom:-120px;
                }

                @media(max-width:991px){

                    .hp-line{
                        left:20px;
                    }

                    .hp-item,
                    .hp-item.right{
                        width:100%;
                        margin-left:0;
                        padding-left:70px;
                        padding-right:0;
                    }

                    .left .hp-dot,
                    .right .hp-dot{
                        left:8px;
                        right:auto;
                    }

                }

                @media(max-width:768px){

                    .hp-section{
                        padding:100px 18px;
                    }

                    .hp-header h2{
                        letter-spacing:-2px;
                    }

                    .hp-number{
                        font-size:44px;
                    }

                    .hp-card h3{
                        font-size:26px;
                    }

                }

            `}</style>

            </section>
        </>
    );
};

export default HiringProcess;